import apiClient from '../../api/http-common';

export interface ILoginCredentials {
  email: string;
  password: string;
}

interface ILoginResponse {
  token: string;
  expired: string;
  tfaRequired: boolean | number;
  tfaType: string;
  forceChangePassword: boolean | number;
}

interface IDOcsResponse {
  files: [];
}
const loginRequest = (data: any) =>
  apiClient.post('/admin/login', data)

/* const loginRequest = async (data: ILoginCredentials) => {
  const response = await apiClient.post<ILoginResponse>('/login', data);

  return response.data;
}; */

const refreshTokenRequest = async () => {
  const response = await apiClient.post('/refresh-token');

  return response.data;
};

const getSystemData = () => apiClient.post<SystemDataType>('/get-system-data');

//Farmer organization data
const getFarmerOrganizationLogo = () => apiClient.post<SystemDataType>('/settings/get-logo');
const getFarmerOrganizationHeadIcon = () => apiClient.post<SystemDataType>('/settings/get-head-icon');

const languageUpdate = (languageId: number) =>
  apiClient.post('/profile/language-update', { languageId: languageId });

const forgotPassword = (data) => apiClient.post('/forgot-password', data);

const setPasswordCheck = (data) => apiClient.post('/set-password-check', data);

const setPassword = (data) => apiClient.post('/set-password', data);

const resetPassword = (data) => apiClient.post('/reset-password', data);

const resetPasswordCheck = (data) => apiClient.post('/reset-password-check', data);

const getLogo = () => apiClient.post('/get-logo');

const getCoverImage = () => apiClient.post('/get-cover');

const getSettingsData = (data?) =>
  apiClient.post<any>('get-settings-data', data);

const getFavicon = () => apiClient.post('get-head-icon');

const getTermFile = (data) => apiClient.post('get-term-file', data);

const login2FA = (data) =>
  apiClient.post('/login-2fa', data)

const sendSmsGetData = (data) =>
  apiClient.post<SendSmsGetDataType>('/set-password/get-data', data)

const resendSetPasswordCode = (data) =>
  apiClient.post('/set-password/resend-code', data)

const resetPasswordData = (data) =>
  apiClient.post('/reset-password/get-data', data)

const resendResetPasswordCode = (data) =>
  apiClient.post('/reset-password/resend-code', data)

const updatePassword = (data) =>
  apiClient.post('/profile/password-update', data)

const updatePasswordData = () =>
  apiClient.post('/profile/get-settings-data')

const logout = () =>
  apiClient.post('/logout')

const exchangeAzureToken = (data: { azureToken: string }) =>
  apiClient.post('/auth/azure/exchange-token', data)

const checkEmail = (data) =>
  apiClient.post('/users/check-email', data)

const saveMobileNumber = (data) =>
  apiClient.post('/set-password/send-code', data)

const checkTwoFaCode = (data) =>
  apiClient.post('/set-password/check-code', data)

const checkResetTwoFaCode = (data) =>
  apiClient.post('/reset-password/check-code', data)

const checkAzureToken = (data?) =>
  apiClient.post('/auth/azure', data)

const AuthService = {
  loginRequest,
  refreshTokenRequest,
  getSystemData,
  languageUpdate,
  forgotPassword,
  setPasswordCheck,
  setPassword,
  getLogo,
  resetPassword,
  resetPasswordCheck,
  getSettingsData,
  getCoverImage,
  getFavicon,
  getTermFile,
  login2FA,
  sendSmsGetData,
  resendResetPasswordCode,
  resetPasswordData,
  resendSetPasswordCode,
  updatePassword,
  updatePasswordData,
  checkEmail,
  logout,
  exchangeAzureToken,
  getFarmerOrganizationHeadIcon,
  getFarmerOrganizationLogo,
  saveMobileNumber,
  checkTwoFaCode,
  checkResetTwoFaCode,
  checkAzureToken
};

type DairySettingsType = {
  passwordSecurity: boolean | number
  showMobileOnVerification: boolean | number
  smsVerificationRegistration: boolean | number
  birthDateVisible: boolean | number
}

export type CountryType = {
  id: number
  iso: string
  label: string
  phoneCode: string
}

type UserDataType = {
  companyName: string
  firstName: string
  id: string
  iso: string
  languageId: number
  lastName: string
  mobileNumber: string
  phoneCode: string
  roleSlug: string
  roleType: string
  supplierNo: string
  tfaType: string
  mobileSet: number
}
export interface SendSmsGetDataType {
  dairySettings: DairySettingsType
  user: UserDataType
  countries: CountryType[]
}

export type LanguageType = {
  id: number,
  code: string,
  label: string
  order: number
  icon: string
}

type LoggedType = {
  id: string
  language: LanguageType
  languageId: number
  farmerId?: string
  name: string,
  roleId: number,
  roleSlug: string,
  tfaType: string,
  tfaLogged: number
  popUpsOnLogin: number | boolean
}

type RoleSettings = {
  logoutTime: number
  roleId: number
  tfaAbortTradingSlot: number
  tfaCancellationAmount: number
  tfaConfirmOffers: number
  tfaContractsImport: number
  tfaLogin: number
  tfaNewsletterSend: number
  tfaOffer: number
  tfaPlanning: number
  tfaPublishBasePrice: number
  tfaAbortAmount?: number
  tfaGenerateBankFile?: number
  tfaGenerateMga?: number
  tfaMgaCloseMonth?: number
  tfaArticlesImport: number
}

type TextType = {
  code: string
  id: number
  label: string
  languageId: number
  slug: string
  textId: number
  translation: string
}

export type ModuleType = {
  id: string
  slug: string
  order: number
  label: string
  children?: ModuleType[]
}

type FaqType = {
  icon: string
  positions: string[]
  status: number | boolean
}

export interface SystemDataType {
  amountPrice?: string
  amountVolume: number
  amountUnit: number
  dateDelimiter: string
  dateFormat: string
  chEnv: number
  decimalSeparator: string
  operativeUsersCanSeeFarmersInfo: number
  cloudStorageSettings: { farmer_enabled: 0 | 1 }
  decimals: number
  defaultRowsPerPage: number
  companyName?: string
  firstColor?: string
  isTest: number | boolean
  languages: LanguageType[]
  logged: LoggedType
  faqSettings: FaqType
  message: string
  thousandSeparator: string
  timezone: string
  isOrganization?: boolean
  stonexEnabled: number | boolean
  roles: any[]
  hideMenuAndHeader: number
  roleSettings: RoleSettings
  texts: TextType[]
  modules: ModuleType[]
  mgaBilling: number | boolean
  openedLoginPopups: boolean
}

export default AuthService;
